import styled, { css } from 'styled-components';
import { media } from 'src/components/base';

const spacing = '4px';

interface ClearProps {
  clear: boolean;
}

export const StyledTag = styled.button<ClearProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background: ${p => p.theme.colors.maybeBlue700};
  border: 1px solid transparent;
  border-radius: 5px;
  padding: ${spacing};
  word-break: break-word;
  hyphens: auto;
  min-height: 35px;

  ${media.largeUp`
    min-height: auto;
`}

  &:active {
    background: ${p => p.theme.colors.maybeBlue700};
  }

  ${p =>
    p.clear &&
    css`
      background: ${p.theme.colors.base600};
      padding-right: ${spacing};
      &:active {
        background: ${p.theme.colors.base700};
      }
    `}
`;

export const TagGroup = styled.span`
  color: ${p => p.theme.colors.base0};
  margin-right: ${spacing};
`;

export const TagValue = styled.span<ClearProps>`
  color: ${p => p.theme.colors.base0};
  font-weight: 600;

  ${p =>
    p.clear &&
    css`
      padding-right: ${spacing};
      &:active {
        background: ${p.theme.colors.base700};
      }
    `}
`;

export const TagClose = styled.span`
  display: flex;
  align-items: center;
  margin-left: ${spacing};
`;
